module.exports = __webpack_public_path__ + "img/1540884633.6b9c44c2.jpg";